import Cookies from 'js-cookie'

const TokenKey = 'Developer-Token'
const UserUUID = 'UserUUID'
const UserInfo = 'UserInfo'
const Nickname = 'Nickname'
const PlatformUuid = 'PlatformUuid'
const PlatformName = 'PlatformName'
const HasPackage = 'HasPackage'
const IsBasic = 'IsBasic'
const IsAuthOfficial = 'IsAuthOfficial'
const SnapshotId = 'SnapshotId'
const IsOver = 'IsOver'
const HeadImg = 'HeadImg'
const IsDeveloper = 'IsDeveloper'

// 肯德基相关
const PlatformUuidKfc = 'PlatformUuidKfc' // 公众号uuid
const PlatformNameKfc = 'PlatformNameKfc' // 公众号名称
const HeadImgKfc = 'HeadImgKfc'           // 公众号头像
const IsAuthKfc = 'IsAuthKfc'             // 公众号是否授权

export function getToken() {
  return Cookies.get(TokenKey)?Cookies.get(TokenKey):''
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserUUID() {
  return Cookies.get(UserUUID)
}

export function setUserUUID(userUUID) {
  return Cookies.set(UserUUID, userUUID)
}

export function removeUserUUID() {
  return Cookies.remove(UserUUID)
}

export function isLogin() {
  return !!Cookies.get(TokenKey)
}

export function getUserInfo() {
  let str = Cookies.get(UserInfo)
  return typeof str == 'string' && str !== '' && str !== null ? JSON.parse(str) : '';
}

export function setUserInfo(data) {
  let str = JSON.stringify(data);
  return Cookies.set(UserInfo, str)
}

export function removeUserInfo(data) {
  return Cookies.remove(UserInfo)
}

export function getNickname() {
  return Cookies.get(Nickname)
}

export function setNickname(nickname ) {
  return Cookies.set(Nickname, nickname)
}

export function removeNickname() {
  return Cookies.remove(Nickname)
}

export function getPlatformUuid() {
  return Cookies.get(PlatformUuid)
}

export function setPlatformUuid(platformUuid){
  return Cookies.set(PlatformUuid, platformUuid)
}

export function removePlatformUuid() {
  return Cookies.remove(PlatformUuid)
}

export function getPlatformName() {
  return Cookies.get(PlatformName)
}

export function setPlatformName(platformName){
  return Cookies.set(PlatformName, platformName)
}

export function removePlatformName() {
  return Cookies.remove(PlatformName)
}

export function getHasPackage() {
  return Cookies.get(HasPackage)
}

export function setHasPackage(hasPackage){
  return Cookies.set(HasPackage, hasPackage)
}

export function removeHasPackage() {
  return Cookies.remove(HasPackage)
}

export function getIsBasic() {
  return Cookies.get(IsBasic)
}

export function setIsBasic(isBasic){
  return Cookies.set(IsBasic, isBasic)
}

export function removeIsBasic() {
  return Cookies.remove(IsBasic)
}

export function getIsAuthOfficial() {
  return Cookies.get(IsAuthOfficial)
}

export function setIsAuthOfficial(isAuthOfficial){
  return Cookies.set(IsAuthOfficial, isAuthOfficial)
}

export function removeIsAuthOfficial() {
  return Cookies.remove(IsAuthOfficial)
}

export function getIsOver() {
  return Cookies.get(IsOver)
}

export function setIsOver(isOver){
  return Cookies.set(IsOver, isOver)
}

export function removeIsOver() {
  return Cookies.remove(IsOver)
}

export function getSnaphotId() {
  return Cookies.get(SnapshotId)
}

export function setSnapshotId(snapshotId){
  return Cookies.set(SnapshotId, snapshotId)
}

export function removeSnapshotId() {
  return Cookies.remove(SnapshotId)
}

export function getHeadImg() {
  return Cookies.get(HeadImg)
}

export function setHeadImg(headImg){
  return Cookies.set(HeadImg, headImg)
}

export function removeHeadImg() {
  return Cookies.remove(HeadImg)
}

export function getIsDeveloper() {
  return Cookies.get(IsDeveloper)
}

export function setIsDeveloper(isDeveloper){
  return Cookies.set(IsDeveloper, isDeveloper)
}

export function removeIsDeveloper() {
  return Cookies.remove(IsDeveloper)
}

// 肯德基相关
export function getPlatformUuidKfc() {
  return Cookies.get(PlatformUuidKfc)
}

export function setPlatformUuidKfc(platformUuid){
  return Cookies.set(PlatformUuidKfc, platformUuid)
}

export function removePlatformUuidKfc() {
  return Cookies.remove(PlatformUuidKfc)
}

export function getPlatformNameKfc() {
  return Cookies.get(PlatformNameKfc)
}

export function setPlatformNameKfc(platformName){
  return Cookies.set(PlatformNameKfc, platformName)
}

export function removePlatformNameKfc() {
  return Cookies.remove(PlatformNameKfc)
}

export function getHeadImgKfc() {
  return Cookies.get(HeadImgKfc)
}

export function setHeadImgKfc(headImg){
  return Cookies.set(HeadImgKfc, headImg)
}

export function removeHeadImgKfc() {
  return Cookies.remove(HeadImgKfc)
}

export function getIsAuthKfc() {
  return Cookies.get(IsAuthKfc)
}

export function setIsAuthKfc(isAuth){
  console.log(isAuth)
  return Cookies.set(IsAuthKfc, isAuth)
}

export function removeIsAuthKfc() {
  return Cookies.remove(IsAuthKfc)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js